export enum AudienceSummaryItemType {
	AudienceName = 'AudienceName',
	OpenCloseDates = 'OpenCloseDates',
	DistributionType = 'DistributionType',
	DistributionFile = 'DistributionFile',
	DistributionHierarchy = 'DistributionHierarchy',
	Invite = 'Invite',
	Reminder = 'Reminder',
	AllReminders = 'AllReminders',
	SurveyLink = 'SurveyLink',
	IsTestAudience = 'IsTestAudience',
	SsoAttribute = 'SsoAttribute',
}
